export const FETCH_ALL_TYPES = 'fetchAllTypes'; // eslint-disable-line
